import { List, ListItem, ListItemButton } from '@mui/material';
import { ReactNode } from 'react';
import { PopupContentProps } from './ButtonDropdown';

interface PopupListBaseProps<T> extends PopupContentProps {
	items?: T[];
	getItemDisplay: (item: T) => string | ReactNode;
	/** If no options are available, this list item will be displayed */
	noOptionsDisplay?: string;
	className?: string;
	listItemButtonClassName?: string;
}

interface ConcretePopupListProps<T> extends PopupListBaseProps<T> {
	onItemSelect: (value: T) => void;
	/** When present, includes an null option with the given text */
	emptyValueDisplay: undefined;
}

interface NullablePopupListProps<T> extends PopupListBaseProps<T> {
	onItemSelect: (value: T | null) => void;
	/** When present, includes an null option with the given text */
	emptyValueDisplay: string;
}

type PopupListProps<T> = NullablePopupListProps<T> | ConcretePopupListProps<T>;

/**
 * Generic PopupList Component used as a template for the ButtonDropdown Popup Component
 */
export default function PopupList<T>(props: PopupListProps<T>) {
	return (
		<List className={props.className}>
			{props.noOptionsDisplay && props.items?.length === 0 && <ListItem>{props.noOptionsDisplay}</ListItem>}
			{props.emptyValueDisplay && (
				<ListItemButton
					onClick={() => {
						props.onItemSelect(null);
						props.closeMenu();
					}}
					className={props.listItemButtonClassName}
				>
					{props.emptyValueDisplay}
				</ListItemButton>
			)}
			{props.items?.map((i, index) => (
				<ListItemButton
					key={`generic-list-item-${index.toString()}`}
					onClick={() => {
						props.onItemSelect(i);
						props.closeMenu();
					}}
					className={props.listItemButtonClassName}
				>
					{props.getItemDisplay(i)}
				</ListItemButton>
			))}
		</List>
	);
}
